var map = {
	"./": 305,
	"./App": 555,
	"./App.js": 555,
	"./components/Born/Born": 906,
	"./components/Born/Born.js": 906,
	"./components/Cursoul/Coursoul": 587,
	"./components/Cursoul/Coursoul.js": 587,
	"./components/Featured/Aside": 978,
	"./components/Featured/Aside.js": 978,
	"./components/Featured/Collection": 326,
	"./components/Featured/Collection.js": 326,
	"./components/Featured/Feature": 14,
	"./components/Featured/Feature.js": 14,
	"./components/favorite/Favorite": 762,
	"./components/favorite/Favorite.js": 762,
	"./components/favorite/Video": 793,
	"./components/favorite/Video.js": 793,
	"./components/navbar/navbar": 882,
	"./components/navbar/navbar.js": 882,
	"./data/Born": 441,
	"./data/Born.js": 441,
	"./data/Collectiondata": 213,
	"./data/Collectiondata.js": 213,
	"./data/Coming": 353,
	"./data/Coming.js": 353,
	"./data/Explore": 99,
	"./data/Explore.js": 99,
	"./data/aside": 649,
	"./data/aside.js": 649,
	"./data/crdata": 666,
	"./data/crdata.js": 666,
	"./data/fav": 650,
	"./data/fav.js": 650,
	"./data/prime": 850,
	"./data/prime.js": 850,
	"./data/video": 846,
	"./data/video.js": 846,
	"./images/MV5BOTIyNzQwN2MtZmRkNS00NDM5LTk3MTgtNDBkNWIzNmRmYmVlXkEyXkFqcGdeQXVyMTEyMjM2NDc2._V1_QL75_UX380_CR0,0,380,214_.jpg": 93,
	"./images/MV5BZDYxYmZmNzktZGQ4ZC00Y2YwLThmYjEtZDQzNWZkMGVjNWM3XkEyXkFqcGdeQXVyMTEyMjM2NDc2._V1_QL75_UX380_CR0,0,380,214_.jpg": 563,
	"./images/MV5BZDc5MzUwOTEtOTVmNS00Y2YyLThlZTktYmQxMDQ4MzI4NWZjXkEyXkFqcGdeQXVyMTEyMjM2NDc2._V1_QL75_UX380_CR0,0,380,214_.jpg": 515,
	"./images/beginner.jpeg": 218,
	"./images/boy.jpeg": 691,
	"./images/photo.jpg": 201,
	"./images/poster.jpeg": 831,
	"./images/this.jpg": 25,
	"./index": 305,
	"./index.js": 305,
	"./style.css": 798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;